interface HierarchyOption {
  value: string;
  label: string;
}

interface HierarchyFiltersInput {
  SuperintendenteSelecionado?: HierarchyOption | null;
  EquipeSelecionada?: HierarchyOption | null;
  CorretorSelecionado?: HierarchyOption | null;
  IdsCorretores?: Array<HierarchyOption | string>;
  IdsEquipes?: Array<HierarchyOption | string>;
}

const extractValues = (
  items: Array<HierarchyOption | string> | undefined
): string[] | undefined => {
  if (!items || items.length === 0) return undefined;
  return items
    .map((item) => (typeof item === "string" ? item : item?.value ?? ""))
    .filter(Boolean);
};

export interface ResolvedHierarchyFilters {
  IdsCorretores?: string[];
  IdUsuarioGerente?: string[];
  IdUsuarioSuperintendente?: string[];
  IdsEquipes?: string[];
}

export function resolveHierarchyFilters(
  filters: HierarchyFiltersInput
): ResolvedHierarchyFilters {
  if (filters.CorretorSelecionado?.value) {
    return { IdsCorretores: [filters.CorretorSelecionado.value] };
  }

  if (filters.EquipeSelecionada?.value) {
    return { IdUsuarioGerente: [filters.EquipeSelecionada.value] };
  }

  if (filters.SuperintendenteSelecionado?.value) {
    return {
      IdUsuarioSuperintendente: [filters.SuperintendenteSelecionado.value],
    };
  }

  const corretorIds = extractValues(filters.IdsCorretores);
  if (corretorIds?.length) {
    return { IdsCorretores: corretorIds };
  }

  const equipeIds = extractValues(filters.IdsEquipes);
  if (equipeIds?.length) {
    return { IdsEquipes: equipeIds };
  }

  return {};
}
